﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { config } from '../../assets/config';
import {Intercalaire} from '../_models/intercalaire';
import {LexiboxImage} from '../_models/lexiboxImage';

@Injectable()
export class LexiboxService {
    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<LexiboxImage[]>(`${config.apiUrl}/lexibox`);
    }

    getById(id: number) {
        return this.http.get(`${config.apiUrl}/lexibox/` + id);
    }

    getByPatientId(id: string) {
        const params = new HttpParams().set('filter', '{"order": "id DESC"}');
        return this.http.get(`${config.apiUrl}/patients/` + id + '/lexibox', {params});
    }

    register(lexiboxImage: LexiboxImage) {
        return this.http.post(`${config.apiUrl}/classeurCategories`, lexiboxImage);
    }

    registerByPatientId(id: string, lexiboxImage: LexiboxImage) {
        return this.http.post(`${config.apiUrl}/patients/` + id + '/lexibox', lexiboxImage, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    update(lexiboxImage: LexiboxImage) {
        return this.http.put(`${config.apiUrl}/lexibox/` + lexiboxImage.id, lexiboxImage);
    }

    delete(id: string) {
        return this.http.delete(`${config.apiUrl}/lexibox/` + id);
    }

    uploadFile(file) {

        const formData = new FormData();
        formData.append('stoveImage', file, file.name);


         let headers: Headers = new Headers();
         headers.append('Accept', 'multipart/form-data');
         headers.append('Content-Type', 'application/x-www-form-urlencoded');

        return this.http.post(
            `${config.apiUrl}/attachments/files/upload`,
            formData,
            {
                params: {
                    clientFilename: file.name,
                    mimeType: file.type
                }
            }
        );
    }

    assignPicture(patientId: string, imageId: string, pictureId: string, thumbnailId: string) {

        const data = {
            picture: pictureId,
            thumbnail: thumbnailId,
        }
        return this.http.put(
            `${config.apiUrl}/patients/` + patientId + '/lexibox/' + imageId,
            data,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );
    }
}
